export const GAME_CONFIG = {
  width: 480,
  height: 800,
  gravity: 800,
  backgroundColor: '#1a1a2e',
  debug: false,
} as const;

export const PLAYER_CONFIG = {
  speed: 240,
  jumpForce: -380,  // Good jump height (~90px max)
  dashForce: 400,
  dashCooldown: 1200,
  maxHealth: 3,
  invincibilityDuration: 600,
  parryWindow: 180,
} as const;

export const CHARACTERS = {
  david: {
    name: 'David',
    role: 'Dad',
    color: 0x1a3a5c,
    health: 4,
    speed: 1.0,
    ability: 'Dad Patience',
    abilityDescription: '2s invincibility',
  },
  enny: {
    name: 'Enny',
    role: 'Mom',
    color: 0x722f37,
    health: 3,
    speed: 1.2,
    ability: 'Mom Look',
    abilityDescription: 'Freeze enemies 1s',
  },
  adam: {
    name: 'Adam',
    role: 'Big Brother',
    color: 0x2563eb,
    health: 3,
    speed: 1.0,
    ability: 'Big Brother Boost',
    abilityDescription: 'Extra jump height',
    birthYear: 2014,
  },
  eli: {
    name: 'Eli',
    role: 'The Wild Card',
    color: 0x16a34a,
    health: 3,
    speed: 1.2,
    ability: 'Chaos Roll',
    abilityDescription: 'Random power-up',
    birthYear: 2015,
  },
  daniel: {
    name: 'Daniel',
    role: 'The Wildling',
    color: 0xea580c,
    health: 3,
    speed: 1.4,
    ability: 'Turbo Tantrum',
    abilityDescription: 'Speed burst',
    birthYear: 2018,
  },
  emily: {
    name: 'Emily',
    role: 'Secret Weapon',
    color: 0xc026d3,
    health: 2,
    speed: 0.8,
    ability: 'Cuteness Overload',
    abilityDescription: 'Charm enemies',
    birthYear: 2021,
  },
} as const;

export const WORLDS = [
  {
    id: 1,
    name: 'The Awakening',
    theme: 'Morning Routine',
    levels: [
      { id: '1-1', name: 'The Blanket Fortress', type: 'boss' },
      { id: '1-2', name: 'Clothes Chaos', type: 'run' },
      { id: '1-3', name: 'The Missing Shoe Quest', type: 'run' },
      { id: '1-B', name: 'Morning Routine Titan', type: 'worldboss' },
    ],
  },
  {
    id: 2,
    name: 'The Institutions',
    theme: 'School & Homework',
    levels: [
      { id: '2-1', name: 'Kindergarten Conquest', type: 'boss' },
      { id: '2-2', name: 'Homework Hydra', type: 'boss' },
      { id: '2-3', name: 'Friendship Trials', type: 'run' },
      { id: '2-B', name: 'Institution Amalgamation', type: 'worldboss' },
    ],
  },
  {
    id: 3,
    name: 'The Feeding Hour',
    theme: 'Mealtime Battles',
    levels: [
      { id: '3-1', name: 'Vegetable Vendetta', type: 'boss' },
      { id: '3-2', name: 'Snack Siege', type: 'run' },
      { id: '3-3', name: 'Restaurant Expedition', type: 'boss' },
      { id: '3-B', name: 'Dinner Table Titan', type: 'worldboss' },
    ],
  },
  {
    id: 4,
    name: 'The Cleansing Trials',
    theme: 'Bath & Hygiene',
    levels: [
      { id: '4-1', name: 'Soapy Showdown', type: 'boss' },
      { id: '4-2', name: 'Shampoo Standoff', type: 'boss' },
      { id: '4-3', name: 'Teeth War', type: 'run' },
      { id: '4-B', name: 'Cleanliness Colossus', type: 'worldboss' },
    ],
  },
  {
    id: 5,
    name: 'The Final Rest',
    theme: 'Bedtime',
    levels: [
      { id: '5-1', name: 'One More Story', type: 'run' },
      { id: '5-2', name: 'Water. Bathroom. Not Tired.', type: 'boss' },
      { id: '5-3', name: 'The Midnight Visitor', type: 'boss' },
      { id: '5-B', name: "Sandman's Challenge", type: 'worldboss' },
    ],
  },
  {
    id: 6,
    name: 'Shabbat Showdown',
    theme: 'Friday Night Dinner',
    levels: [
      { id: '6-F', name: 'Family Dinner: The Final Form', type: 'finale' },
    ],
  },
] as const;

